import React, { useEffect, useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link, useParams } from 'react-router-dom';
import { getSessionObj, RootState, UrlUtils } from '@share/utils';
import { getCondoReviewBook } from '@store/slices';
import { CONDO_SESSION_KEY, Routes } from '@share/constants';
import { ILuxuryHome, ISessionKey } from '@share/common-types';
import { LuxuryHomesDetailsImages } from '../commons/images';
import { SkeletonReviewBook } from '../../common';
import { LuxuryHomesMain } from '../commons/main/component';
import { CondoReviewBook } from '../../condo';
import { CondoUnitInfo } from '../../condo/condo-review-book/condo-unit-info';
import './style.scss';

export const LuxuryHomesCheckout: React.FC = () => {

  const dispatch = useDispatch();
  
  const { propertyId } = useParams<{ propertyId: string }>();
  const { packageId } = useParams<{ packageId: string }>();
  const { placeId } = useParams<{ placeId: string }>();
  
  const { condoBookingSummary, loading } = useSelector((state: RootState) => state.condoReviewBookStore);
  const { condosCountriesCode } = useSelector((state: RootState) => state.condosStaticStore);
  const { sessionKey } = useSelector((state: RootState) => state.condosStore);
  const { account } = useSelector((state: RootState) => state.loginStore);
  const { homes } = useSelector((state: RootState) => state.luxuryHomesStore);

  const home = useMemo(() => homes?.filter((home: ILuxuryHome) => home.id === parseInt(propertyId))?.[0], [homes, propertyId]);

  useEffect(() => {
    window.scrollTo(0, 0);

    const values = UrlUtils.getValues();
    const session = getSessionObj(values[CONDO_SESSION_KEY] as ISessionKey, values[CONDO_SESSION_KEY] as ISessionKey);

    dispatch(getCondoReviewBook(Number(propertyId), packageId, sessionKey || session, false));
  }, []);

  return (
    <LuxuryHomesMain route={placeId ? Routes.LuxuryHomesPlace : Routes.LuxuryHomesDetails} className="luxury-homes-checkout" headerProps={{ fixed: true, className: 'luxury-homes-header__blue' }}>
      <LuxuryHomesDetailsImages home={home} />

      <div className="review-book-wrapper print">
        <div className="review-book-wrapper__header print">
          <div className="review-book-wrapper__back-link">
            <Link to={`/${account?.name}${Routes.Condo}/${propertyId}${location.search}`}>
              <FormattedMessage id="back.to.condo" />
            </Link>
          </div>
          <h4 className="review-book-wrapper__title secondary-font">
            <FormattedMessage id="review.book" />
          </h4>
          <p className="review-book-wrapper__description">
            <FormattedMessage id="enter.your.details" />
          </p>
        </div>
        
        {loading ? <SkeletonReviewBook /> : null}
        {condoBookingSummary && !loading && condosCountriesCode ? (
          <div className="review-book-wrapper__content">
            <CondoReviewBook condoId={Number(propertyId)} availabilityId={packageId} hideUnitInfo />
            <CondoUnitInfo />
          </div>
        ) : null}
      </div>
    </LuxuryHomesMain>
  );
}; 